import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ApiErrorMessage } from "@advosys/component-advosys-react";
import { Dialog, PdfViewer, Spinner } from "@advosys/component-react";
import { actions as pageActions } from "../../dynamic-invoice-page-store";
import { k } from "./preview-dialog-i18n";
import { actions as previewDialogActions } from "./preview-dialog-store";
const mapStateToProps = (state) => state.dynamicInvoices.dynamicInvoicesPages.dynamicInvoicesPage.previewDialog;
const actions = {
    ...previewDialogActions,
    hidePreviewDialog: pageActions.hidePreviewDialog
};
const Content = (props) => {
    switch (props.loading.state) {
        case "has-finished":
            return _jsx(PdfViewer, { base64data: props.loading.data.base64 });
        case "failed":
            return _jsx(ApiErrorMessage, { message: props.loading.error });
        default:
            return _jsx(Spinner, {});
    }
};
const PreviewDialogBase = (props) => {
    const { t } = useTranslation();
    useEffect(() => {
        props.getPreviewRequest(props.preparedInvoice.id);
        return () => {
            props.clearPreviewDialog();
        };
    }, []);
    return (_jsx(Dialog, { size: "takeover", onDismiss: props.hidePreviewDialog, header: t(k.dialogHeader), children: _jsx(Content, { loading: props.loading }) }));
};
export const PreviewDialog = connect(mapStateToProps, actions)(PreviewDialogBase);
